import React from 'react';
import { 
  BottomNavigation, 
  BottomNavigationAction, 
  useMediaQuery, 
  useTheme,
  Box 
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BarChartIcon from '@mui/icons-material/BarChart';
import AssessmentIcon from '@mui/icons-material/Assessment';

const MobileBottomNavigation = ({ dashboardTab, setDashboardTab }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (!isMobile) return null;

  return (
    <Box sx={{ 
      position: 'fixed', 
      bottom: 0, 
      left: 0, 
      right: 0, 
      zIndex: 1000,
      bgcolor: 'background.paper',
      borderTop: 1,
      borderColor: 'divider'
    }}>
      <BottomNavigation
        value={dashboardTab}
        onChange={(event, newValue) => setDashboardTab(newValue)}
        showLabels
        sx={{
          '& .MuiBottomNavigationAction-root': {
            color: 'text.secondary',
            '&.Mui-selected': {
              color: 'primary.main'
            }
          }
        }}
      >
        <BottomNavigationAction 
          label="Overview" 
          icon={<DashboardIcon />} 
          value={0}
        />
        <BottomNavigationAction 
          label="Analytics" 
          icon={<BarChartIcon />} 
          value={1}
        />
        <BottomNavigationAction 
          label="Bookings" 
          icon={<AssignmentIcon />} 
          value={2}
        />
        <BottomNavigationAction 
          label="Reports" 
          icon={<AssessmentIcon />} 
          value={3}
        />
      </BottomNavigation>
    </Box>
  );
};

export default MobileBottomNavigation;